import React from 'react';
import { cn } from '../../lib/utils';

export function DataSourceChip({ label, className }) {
  if (!label) return null;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] text-slate-600 shadow-sm',
        className
      )}
      aria-live="polite"
    >
      <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" />
      <span>
        Data source: <span className="font-semibold text-slate-700">{label}</span>
      </span>
    </div>
  );
}
